var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-graph"},[_c('div',{class:("default-graph-img default-graph-img" + _vm.type)}),(_vm.text)?_c('div',{staticClass:"default-graph-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }